import {GeneralAction} from '../../../@types/actions';
import {GET_ACTIVE_EXTRA} from '../../../constants/ExtraConstants';

export const GetActiveExtraAction = (): GeneralAction<undefined> => ({
    type: GET_ACTIVE_EXTRA,
    payload: undefined,
});
